import React from 'react';
import WName from '../WName';
import QL from './QuestionLink';
import PL from '../problems/ProblemLink';
import AL from '../angles/AngleLink';
import NW from '../neologisms/NewWord';
import OML from '../ormaybe/OrMaybeLink';
import LRL from '../longreads/LongReadLink';
import {E1, E2, Qual, Fibonacci} from '../common';

// ‘’ –

// Why is it always the fibonacci sequence? (No resilience. ALWAYS.)
export const fibonacci = {
  name: "fibonacci",
  prelude: <span><Fibonacci cap delimiter=". " reps={[4, 6]} noQL>always</Fibonacci>. No <AL>resilience</AL>. <i>Always.</i></span>,
  question: <span>Why is it <i>always</i> the Fibonacci sequence?</span>,
  answerPreview: <div className="answer-preview">
    <p>Because it does not represent <AL>resilience</AL>. It represents <i><LRL>reactivity</LRL></i>.</p>
    <p>It also represents a case in which it’s just, frankly, <QL>re-inventing the wheel</QL> to waste the potentially-conscious (<NW>POCA</NW>) <QL name="pg.">mind</QL>’s <NW>co-fo</NW> on something that can be done by a <PL name="ai">machine</PL>.</p>
  </div>,
  answer: <div className="answer">
    <p>For a human, it takes <i><QL>time</QL></i> (and memory) to calculate the next values of the Fibonacci sequence. The whole thing can be written as a <i>φ</i>-rule: <i>φ</i>(<i>a</i><sub><i>n</i></sub>) = (<i>n</i> {'<'} 2 ∧ <i>a</i> = 1) ∨ <i>a</i><sub><i>n</i></sub> = <i>a</i><sub><i>n</i> – 1</sub> + <i>a</i><sub><i>n</i> – 2</sub></p>
    <p>A computer can easily generate numbers in this sequence and check them. (such as: is 317,812 a ‘Fibonacci’ number? No; actually, it’s 317,811.) For a human, <AL>handicapped</AL> as we are by the real-world <AL>limits</AL> of our <NW>khets</NW>, this is a waste of time.</p>
    <p>Why? Because it <i>can</i> be automated.</p>
    <p>Our <PL name="nazis">danger</PL> is trying to use <PL name="ai">automation</PL> for things that are NP or even algorithmically <i>undecideable</i> (like the ‘halting problem’). Automation is not <QL>consciousness</QL>. It cannot replace <QL name="salvation.">actually thinking</QL>.</p>
    <p><AL>Together</AL>.</p>
  </div>,
};
